module.exports = __webpack_public_path__ + "img/Vehicle_Selected.5feae787.svg";